import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { GoToStep1 } from '../actions/app.js';
import { ConfirmFood, LoadFood } from '../actions/food.js';
import { FoodDialog } from '../components/FoodDialog.js';

export function FoodSelector() {
    const confirmedTickets = useSelector(state => state.cart.confirmed_tickets);
    const foodTicket = useSelector(state => state.cart.food_ticket);
    const food = useSelector(state => state.food.food);
    const confirmedFood = useSelector(state => state.cart.confirmed_food);

    const dispatch = useDispatch();

    const hasConfirmedTickets = confirmedTickets.length > 0;
    const hasFoodTicket = foodTicket != null;
    const hasConfirmedFood = confirmedFood != null;

    const shouldShowFoodTicketSelector = hasConfirmedTickets &&
        hasFoodTicket &&
        !hasConfirmedFood;

    function onConfirmFood(food) {
        dispatch(ConfirmFood(food));
    }

    function onCancelFood() {
        dispatch(GoToStep1());
    }

    useEffect(() => {
        if (foodTicket) {
            dispatch(LoadFood(foodTicket));
        }
    }, [foodTicket]);

    if (!shouldShowFoodTicketSelector) {
        return null;
    }

    return (
        <FoodDialog
            visible={shouldShowFoodTicketSelector}
            food={food}
            guests={confirmedTickets.length}
            onConfirm={onConfirmFood}
            onClose={onCancelFood}
        />
    );
}
